import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="addable"
export default class extends Controller {
  static targets = [
    "template"
  ]

  connect() {
  }

  addAnother(e) {
    e.preventDefault()
    this.templateTarget.classList.remove('hidden')
    const content = this.templateTarget.outerHTML
    this.templateTarget.classList.add('hidden')
    this.element.insertAdjacentHTML('beforebegin', content)
  }
}
